import {Link} from 'lib/ui/link';

export class ProductLink extends Link {
    constructor(options) {
        const {product} = options;

        super({
            label: product.title,
            href: product.href,
        });

        this.product = product;
    }
}
